<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}
.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}
.management-name {
  flex-shrink: 0;
}
.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}
.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}
.input-item .input-title {
  margin-right: 14px;
}
.add {
  text-align: left;
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}
.del {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}
.product-item {
  display: flex;
  margin-top: 10px;
}
.product {
  display: flex;
  align-items: center;
}
.product-img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}
.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<template>
  <div class="content"  v-loading.fullscreen.lock="fullscreenLoading" >
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">委托方</div>
          <el-select size="mini" class="ipt-sty" v-model="page.sendTenantGuid" filterable placeholder="请选择委托方" style="width: 260px">
            <el-option
              v-for="item in sendTenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">模版名称</div>
          <el-input size="mini" class="ipt-sty" v-model="page.templateName" placeholder="请输入模版名称"></el-input>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <el-table :data="tableData" :height="tableHeight" stripe border style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="templateName"
          label="模版名称"
         show-overflow-tooltip 
          header-align="center"
          align="left"
          width="280"
        >
          <template slot-scope="scope">{{ scope.row.templateName }}</template>
        </el-table-column>
        <el-table-column prop="tenantName" label="发布药企" show-overflow-tooltip header-align="center" align="left"   width="200">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>
        <el-table-column
          prop="organisationList"
          label="发布部门"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="100"
        >
          <template slot-scope="scope">{{ getDeliverName(scope.row.organisationInfo) }}</template>
        </el-table-column>
        <el-table-column prop="taskTotal" label="系统功能" show-overflow-tooltip header-align="center" align="left"   width="100">
          <template slot-scope="scope">共{{ scope.row.taskTotal }}项</template>
        </el-table-column>
        <el-table-column prop="isUse" label="状态"   width="60" header-align="center" align="left">
          <template slot-scope="scope">{{scope.row.superState=='T'?'草稿中' :scope.row.isUse == 'Y' ? '启用' : '禁用' }}</template>
        </el-table-column>
        <el-table-column prop="isAllowTenantUse"   width="100" label="支持企业派发" header-align="center" align="left">
          <template slot-scope="scope">{{scope.row.isAllowTenantUse=='Y'?'支持' :'不支持'}}</template>
        </el-table-column>
        
        <el-table-column prop="createTime"   width="100" label="创建时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>

        
        <el-table-column min-width="280px" label="操作" header-align="center" align="center" fixed="right">>
          <template slot-scope="scope">
            <a v-if="scope.row.isAllowTenantUse == 'N'" class="txt-color" @click="editTemplate(scope.row.guid, 'Y')">支持企业派发</a>
            <a v-if="scope.row.isAllowTenantUse == 'Y'" class="txt-color" @click="editTemplate(scope.row.guid, 'N')">禁止企业派发</a>
            <a v-if="scope.row.isUse == 'Y' &&scope.row.superState !='T'" class="txt-color" @click="editVersion(scope.row.guid, 'N')">设为禁用</a>
            <a v-if="scope.row.isUse == 'N' &&scope.row.superState !='T'" class="txt-color" @click="editVersion(scope.row.guid, 'Y')">设为启用 ｜</a>
            <a class="txt-color" @click="editVersion(scope.row.guid, 'D')">详情</a>
            <a class="txt-color" @click="editVersion(scope.row.guid, 'U')">编辑</a>
            <a class="txt-color" @click="delVersion(scope.row)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50,100,200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      tableHeight: window.innerHeight - 220,
      textTitle: '新增任务大类',
      organisationList: [],
      page: {
        serviceTenantGuid:localStorage.guid,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        isSuper: 'N',
        sendTenantGuid:'',
        tenantGuid:localStorage.guid,
        tenantName: '', //药企名称
        templateName: '', //模版名称
      },
      tenantList: [],
      sendTenantList:[],
      tableData: [],
    };
  },
  created() {
    this.getList();
    // this.getTenantList();
    this.getSendTenantList();
  },
  activated(){
    this.getList();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getDeliverName(res) {
      var list = JSON.parse(res);
      var strList = [];
      list.forEach((item) => {
        strList.push(item.name);
      });
      return strList.join('、');
    },

    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['010201','0101'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    search() {
      let self = this;
      self.tableLoading = true;
      this.page.pageIndex = 1;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        isUse:'Y',
        tenantName: '', //药企名称
        templateName: '', //模版名称
        sendTenantGuid:'',
        tenantGuid:localStorage.guid,
        serviceTenantGuid:localStorage.guid
      };
      this.getList();
    },
    addVersion() {
      this.$router.push('/taskTemplateConfEdit?productGuid='+this.$route.query.productGuid);
    },
    editVersion(guid, isUse) {
      if (isUse == 'Y' || isUse == 'N') {
        var self = this;
        var req = {
          isUse: isUse,
          guid: guid,
          isSuper:'N',
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/edit`, req).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('修改成功');
            self.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      } else {
        this.$router.push('/taskTemplateConfEdit?guid=' + guid + '&isUse=' + isUse+'&productGuid='+this.$route.query.productGuid);
      }
    },
    editTemplate(guid,isAllowTenantUse){
        var self = this;
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/update-allow-tenantUse?guid=${guid}&isAllowTenantUse=${isAllowTenantUse}`).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('修改成功');
            self.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });

    },


    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delVersion(item) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/task-set/template/delete?guid=${item.guid}`)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.page.pageIndex = 1;
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        });
    },
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
                '支持企业派发/禁止企业派发：',
                h('br'),
                '1、支持：企业端【任务派发管理】的【自动派发设置】和【临时派发任务】功',
                h('br'),
                '能中可以选择该模版的任务进行派发，每家企业只能设置一个模版为“支持”；',
                h('br'),
                '2、禁止：企业人员无法选择该模版的任务进行派发。',
         
               
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script> 
<style scoped>
.txt-color {
  word-break: keep-all;
}
a.txt-color + a.txt-color::before {
  content: '|';
  display: inline-block;
  margin: 0 4px;
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>